/**
 * Converts bare URLs in an HTML string into clickable <a> tags.
 * Skips URLs already inside HTML attributes (href="...", src="...", etc).
 */
export function linkifyHtml(html: string | null | undefined): string {
  if (!html) return "";

  return html.replace(
    /(?<![="'(])(\bhttps?:\/\/[^\s<>"']+)/g,
    '<a href="$1" target="_blank" rel="noreferrer" class="underline">$1</a>'
  );
}
